
import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { getValuesFromLocalstorage } from "../../Helpers";

const PublicRoutes = () => {
  const params = new URLSearchParams(window.location.search);
  const isImpersonateHandoff =
    params.get("impersonate") === "true" && !!params.get("token");

  // Always allow login page when admin is handing off a new impersonation session,
  // even if a previous user session exists in localStorage.
  if (isImpersonateHandoff) {
    return <Outlet />;
  }

  const userDetails = getValuesFromLocalstorage("userDetails");
  return !userDetails ? <Outlet /> : <Navigate to="/" />;
};

export default PublicRoutes;
